import React, { useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import LinearProgress from "@material-ui/core/LinearProgress";
import { useDispatch, useSelector } from "react-redux";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import { fetchRecurring } from "../../actions/recurring";
import "../payment/PaymentPage.css";
import RecurringHeader from "../../components/recurring/header/RecurringHeader";
import RecurringComponent from "../../components/recurring/body/recurringComponent";

const RecurringPaymentPage = ({ match, history }) => {
  const { params } = match;
  const dispatch = useDispatch();

  const { error, isLoading, recurring } = useSelector(
    state => state.recurringReducer
  );

  const getAttValueFromTheme = useCallback(
    (currentValue, firstAttribute, secondAttribute) => {
      const { theme } = recurring || {};
      return theme &&
        theme.palette &&
        theme.palette[firstAttribute] &&
        theme.palette[firstAttribute][secondAttribute]
        ? theme.palette[firstAttribute][secondAttribute]
        : currentValue;
    },
    [recurring]
  );

  useEffect(() => {
    dispatch(fetchRecurring(params.id));
  }, [dispatch, params.id, history]);

  const theme = createMuiTheme({
    typography: {
      fontSize: 16
    },
    palette: {
      primary: {
        light: getAttValueFromTheme("#29337A", "primary", "light"),
        main: getAttValueFromTheme("#20285f", "primary", "main"),
        dark: getAttValueFromTheme("#171C43", "primary", "dark")
      },
      secondary: {
        main: getAttValueFromTheme("#3775ba", "secondary", "main")
      },
      error: {
        main: getAttValueFromTheme("#db504a", "error", "main")
      },
      background: {
        default: getAttValueFromTheme("#ecebe4", "background", "default"),
        paper: getAttValueFromTheme("#fff", "background", "paper")
      },
      text: {
        primary: getAttValueFromTheme("rgba(0, 0, 0, 0.87)", "text", "primary"),
        secondary: getAttValueFromTheme(
          "rgba(0, 0, 0, 0.54)",
          "text",
          "secondary"
        )
      }
    }
  });

  if (error) {
    return <span>{error}</span>;
  }

  const { plan = {}, currency } = recurring;
  let componentToDisplay;
  if (
    recurring?.status === "OPEN" ||
    recurring?.status === "CLOSED" ||
    recurring?.status === "BOUND"
  ) {
    componentToDisplay = (
      <>
        <RecurringHeader recurring={recurring} />
        <RecurringComponent
          recurring={recurring}
          schedule={plan}
          currency={currency}
        />
      </>
    );
  } else {
    componentToDisplay = <span>Error: recurring state is unknown</span>;
  }

  return (
    <MuiThemeProvider theme={theme}>
      <Paper id="payment-page">
        {isLoading ? <LinearProgress /> : componentToDisplay}
      </Paper>
    </MuiThemeProvider>
  );
};

RecurringPaymentPage.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string.isRequired
    })
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired
};

export default RecurringPaymentPage;
